<template>
<div class="card card--white h-auto w-100">

  <div class="card-header">
    <div class="d-flex bd-highlight">
      <div class="p-2 mt-2 flex-grow-1 bd-highlight">
        <h4 class="ficha-cliente__header">Archivos</h4>
      </div>
    </div>
  </div>
  <div class="card-body" >

    <div v-if="archivos.length===0" class="alert alert-primary" role="alert">No hay Archivos para esta sucursal</div>

    <table class="table table--secondary" v-if="archivos.length>0">
      <thead>
          <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Fecha</th>
              <th>Descripción</th>
              <th>Link</th>
          </tr>
      </thead>
      <tbody>
          <tr v-for="archivo in archivos" :key="archivo.id">

              <td>
                {{archivo.id}}
              </td>
              <td>
                {{archivo.nombre}}
              </td>
              <td>
                {{archivo.periodo | moment("D MMM YYYY")}}
              </td>
              <td>
                {{getDescripcion(archivo)}}
              </td>
              <td>
                  <button-download titulo='Descargar' clases='btn btn-link' :url='`${urlDownload}${archivo.id}/download_file/`' :outputName='getNombre(archivo)' :tipo='getExtension(archivo)' />
              </td>
          </tr>
      </tbody>
    </table>

  </div>

</div>
</template>

<script>
import axios from 'axios'
import ButtonDownload from '@/components/ButtonDownload.vue'

export default {
  components: {
    ButtonDownload
  },
  data () {
    return {
      archivos: [],
      urlDownload: process.env.VUE_APP_URL_DOWNLOAD_ANTECEDENTES || '/archivos/api/archivos/'
    }
  },
  methods: {
    getNombre (archivo) {
      return archivo.nombre.split('.')[0]
    },
    getExtension (archivo) {
      return archivo.nombre.split('.').pop()
    },
    getDescripcion (archivo) {
      return archivo.info?.descripcion
    },
    getFiles () {
      const idAddress = this.$route.params.id
      const url = '/archivos/api/archivos/'
      axios.get(url, { params: { id_direccion: idAddress } })
        .then(response => { this.archivos = response.data })
        .catch(error => console.log(error.data))
    }
  },
  mounted () {
    this.getFiles()
  }
}
</script>
